import React, {useState} from "react";
import "./Scale.css";
import RiddleCard from "../RiddleCard/RiddleCard";

const Scale = ({weight, scaleStatuses, overWriteFunction, index}) => {
    const getIcon = (state, target) => {
        if(state) {
            return <>
                    <div className="scale-target-container">
                        <img className={"button-image"} src={process.env.PUBLIC_URL + '/check-square.svg'} alt="on" />
                        <p>{target}g</p>
                    </div></>
        }
        return <>
            <div className="scale-target-container">
                <img className={"button-image"} src={process.env.PUBLIC_URL + '/square.svg'} alt="off" />
                <p>{target}g</p>
            </div></>
    };
const lookingFor = [14, 33, 57];
const scaleOffset = 623;
    const mainDiv = (
        <>
            <div className="scale-container">
                {scaleStatuses.map((status, index) => (
                    getIcon(status, lookingFor[index])
                ))}
            </div>
            <h4 className="scale-display">{Math.round(weight-scaleOffset)}g</h4>
        </>
    );

    return (
        <RiddleCard title={"Scale"} mainInfo={mainDiv} displayFlexColumn={true} connected={weight != null} overwriteString={overWriteFunction} index={index}></RiddleCard>
    )
}

export default Scale;